<div *ngIf="loading">
  <h3 class="panel-title">Verifying your email address</h3>
  <div class="margin-top"><i class="fa-solid fa-spinner fa-spin"></i> Please wait while we verify your email...</div>
</div>
<div *ngIf="verified">
  <h3 class="panel-title">Thanks for verifying your email address</h3>
  <div class="margin-top" *ngIf="accounts.length === 1; else ambiguousAccountBlock">
    Now that we know who you really are, you can
    <a routerLink="{{ usersLink }}">invite your friends and colleagues</a> to join you.
  </div>
  <ng-template #ambiguousAccountBlock>
    <div class="margin-top">Click <a routerLink="/">here</a> to continue to your account.</div>
  </ng-template>
</div>
<div *ngIf="verificationError">
  <h3 class="panel-title">Hmmm...</h3>
  <div class="margin-top">
    The verification token in the link you've visited has expired or is invalid. Please send a new verification email
    from the Users settings panel in the {{ uiService.productName }} console.
  </div>
</div>
<div *ngIf="!validContext">
  <h3 class="panel-title">Hmmm...</h3>
  <div class="margin-top">
    The link you've visited is missing the required parameters to verify your email address. Do you mind checking the
    link and trying again?
  </div>
</div>
